module.exports = __webpack_public_path__ + "img/牛晓涛.7b377899.png";